module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.title) ? _c('div', {
    staticClass: "weui-cells__title",
    style: (_vm.cleanStyle({
      color: _vm.titleColor
    })),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("title"), _vm._v(" "), _c('div', {
    staticClass: "weui-cells",
    class: {
      'vux-no-group-title': !_vm.title
    },
    style: (_vm.cleanStyle({
      marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
    }))
  }, [_vm._t("after-title"), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (_vm.footerTitle) ? _c('div', {
    staticClass: "weui-cells__title vux-group-footer-title",
    style: (_vm.cleanStyle({
      color: _vm.footerTitleColor
    })),
    domProps: {
      "innerHTML": _vm._s(_vm.footerTitle)
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b996557","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/group/index.vue
// module id = 330
// module chunks = 1